// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./accordion_ripple"
import * as bootstrap from "bootstrap"
import "./cart"
import "./turbo_stream_actions"
import "./gtm_turbo"

window.bootstrap = bootstrap;

//Turbo.session.drive = false;

import {Country, State} from "country-state-city"

// AOS
import AOS from 'aos';

AOS.init({
    duration: 1000,
    once: true
});

// Back to Top
import {addBackToTop} from 'vanilla-back-to-top'

// Chatra - LiveChat
import Chatra from '@chatra/chatra';

let chat_config = {
    setup: {
        buttonSize: 50,
        colors: {
            buttonText: '#ffffff',
            buttonBg: '#663399'
        }
    },
    ID: '7aowCmfBcjkAdYS2R'
}

// Glightbox
import GLightbox from 'glightbox';

// noUiSlider - for range sliders
import noUiSlider from 'nouislider';

window.noUiSlider = noUiSlider;


document.addEventListener("turbo:load", () => {

    Chatra('init', chat_config);

    addBackToTop({
        diameter: 50,
        backgroundColor: 'transparent',
        textColor: '#000'
    });

    const offcanvasElements = document.querySelectorAll('.offcanvas');
    offcanvasElements.forEach(offcanvasEl => {
        // Dispose of any existing instance
        const existingInstance = bootstrap.Offcanvas.getInstance(offcanvasEl);
        if (existingInstance) {
            existingInstance.dispose();
        }

        // Reinitialize
        new bootstrap.Offcanvas(offcanvasEl);
    });

    GLightbox({
        selector: ".lightbox",
        touchNavigation: true,
        showImageTitle: false,
        openEffect: 'zoom',
        closeEffect: 'fade',
        slideExtraAttributes: []
    });
});
